import React from 'react';
import clsx from 'clsx';
import { OptionComponentProps } from 'components/molecules/DropDown/types';

interface Props extends OptionComponentProps {
  disabled?: boolean;
  count?: number;
}

const AddressOption = React.forwardRef<HTMLLIElement, Props>(
  ({ label, selected, onClick, disabled, count, ...props }, ref) => (
    <li
      role="option"
      aria-selected={selected}
      aria-label={label}
      ref={ref}
      className={clsx(
        count ? 'h-18' : 'h-9',
        'w-full px-4 py-2 text-sm leading-5',
        'cursor-pointer list-none',
        selected ? 'bg-blue-4 text-white' : 'bg-white',
        !selected && !disabled && 'hover:bg-light-blue-1',
        'focus:outline-none',
      )}
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
      {...props}
    >
      <div className="truncate w-full">{label}</div>
      {count && <p className="font-semibold">{count}</p>}
    </li>
  ),
);

export default AddressOption;
